module.exports = __webpack_public_path__ + "img/Asas-Sign-in.d3dfd5d9.png";